interface Props {
  readonly size?: number;
  readonly className?: string;
}

export default function ProductDocsIcon(props: Props) {
  const { size = 17, className } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g
        transform="translate(0 .5)"
        stroke="currentColor"
        fill="none"
        fillRule="evenodd"
      >
        <rect x=".5" y=".5" width="12.93" height="12.82" rx="2" />
        <path d="M13.58 2.18h1.04c.76 0 1.38.65 1.38 1.46v10.9c0 .8-.62 1.46-1.38 1.46H3.45c-.76 0-1.38-.65-1.38-1.45v-1.02" />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M3.21 9.38h7.51M3.21 6.91h7.51M3.21 4.44h7.51"
        />
      </g>
    </svg>
  );
}
